import { render } from "./ProfileAutocompleteComponent.vue?vue&type=template&id=15387650&ts=true"
import script from "./ProfileAutocompleteComponent.vue?vue&type=script&lang=ts"
export * from "./ProfileAutocompleteComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__